export default __webpack_public_path__ + "static/media/EcllipseRightTop.b1f02804.svg";